<template>
  <div class="container">
    <div class="dana-mask"></div>
    <div class="dana-content">
      <a href="javascript:;" class="dana-content-close" @click="close"
        >&times;</a
      >
      <div class="dana-content-title">{{ letter.tips }}</div>
      <div class="dana-content-main">{{ letter.danaGetAuthTip }}</div>
      <div class="dana-content-button">
        <a
          href="javascript:;"
          class="dana-content-button-bind"
          @click="goToBind"
          >{{ letter.goToBind }}</a
        >
        <a
          href="javascript:;"
          class="dana-content-button-upgrade"
          @click="upgradePlatformAccount"
          >{{ letter.upgradePlatformAccount }}</a
        >
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'DanaGetAuthPopup',
  emits: ['close', 'goToBind', 'upgradePlatformAccount'],
  computed: {
    ...mapGetters(['letter'])
  },
  methods: {
    close() {
      this.$emit('close')
    },
    goToBind() {
      this.$emit('goToBind')
    },
    upgradePlatformAccount() {
      this.$emit('upgradePlatformAccount')
    }
  }
}
</script>

<style lang="scss" scoped>
a {
  text-decoration: none;
}
.container {
  z-index: 9;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}
.dana-mask {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba($color: #000, $alpha: 0.6);
}
.dana-content {
  box-sizing: border-box;
  z-index: 20;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  margin: auto;
  width: 90%;
  height: 500vh;
  padding: 30vh 22vh;
  background-color: #ffffff;
  border-radius: 6px;

  &-close {
    position: absolute;
    top: 0;
    right: 12vh;
    font-size: 36vh;
    color: #000000;
  }

  &-title {
    margin-bottom: 10vh;
    font-size: 30vh;
    font-weight: bold;
    text-align: center;
  }

  &-main {
    overflow: auto;
    max-height: 300vh;
    margin-bottom: 46vh;
    word-break: break-word;
    font-size: 22vh;
    text-align: left;
  }

  &-button {
    > a {
      box-sizing: border-box;
      display: block;
      margin: 0 auto 22vh;
      width: 80%;
      height: 56vh;
      line-height: 56vh;
      font-size: 22vh;
      text-align: center;
      border-radius: 6px;
    }

    &-bind {
      background-color: #138de4;
      color: #ffffff;
    }

    &-upgrade {
      border: 1px solid #48a8ea;
      color: #000000;
    }
  }
}
</style>
